/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * One step as Save takes it. id: one of the automation's steps (an edit);
 * none: a new step, which ref names so a wait in the same draft can wait
 * for it. Stage 0 is timed from the event; each later stage starts with
 * its one wait, and its other steps are timed from when the wait passed.
 * offset_minutes is when it happens in its stage: in stage 0, from the
 * event, negative before it for kinds that can act before it (a meeting, a
 * date), in the kind's own unit (whole hours or days) for a kind with a
 * timing of its own; later, after its wait passed. A wait has none, except
 * a wait that is the very first step, which people reach at the event's
 * own timing.
 *
 * By action: send takes template_id, send_to, sms and email; task, crm_move
 * and crm_field take config as the choices describe; wait takes config
 * {"conditions": [...]}, each {"wait": "column", "column": "2:13"} or
 * {"wait": "task_status", "step": <an earlier task step's id or ref>,
 * "status": "COMPLETE"}, all of which must hold.
 */
export type StepDraft = {
  id?: number | null;
  ref?: string | null;
  action: StepDraft.action;
  stage?: number;
  offset_minutes?: number;
  ask_first?: boolean;
  approver_roles?: StepDraft.approver_roles;
  template_id?: number | null;
  send_to?: Array<"students" | "parents" | "tutors" | "admins">;
  sms?: boolean;
  email?: boolean;
  config?: any;
};

export namespace StepDraft {
  export enum action {
    SEND = "send",
    TASK = "task",
    CRM_MOVE = "crm_move",
    CRM_FIELD = "crm_field",
    WAIT = "wait",
  }

  export enum approver_roles {
    ADMIN = "admin",
    TUTOR = "tutor",
    BOTH = "both",
  }
}
